import { cn } from "@roman/shared/utils";

interface TitleProps {
  text: string;
  className?: string;
}

export const Title = ({ text, className }: TitleProps) => (
  <div className="relative w-full group my-1 select-none">
    <div className={cn("line-clamp-2 leading-snug", className)}>{text}</div>
    <div
      className={cn(
        "absolute left-0 right-0 top-0 leading-snug pt-1 bg-white group-hover:block hidden z-10 line-clamp-2 overflow-hidden hover:line-clamp-3",
        className,
      )}
    >
      {text}
    </div>
  </div>
);
